import { Button, Dialog, Flex, Link, Text } from '@radix-ui/themes'
import { useState } from 'react'
import { DexRadixSize } from '#app/config/ui.config.ts'
import { useBreakpoints } from '#app/hooks/breakpoints.hook.ts'
import { type SupportContact } from '#app/utils/env.server.ts'
import { DexIconHelp } from '../ui/icons/dex-icons.tsx'

export function SupportDialog({ contacts }: { contacts: SupportContact[] }) {
  const [open, setOpen] = useState(false)
  const { is3xl } = useBreakpoints()

  if (contacts.length === 0) return null

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger aria-label="Support">
        <Button
          variant="soft"
          size={is3xl ? DexRadixSize.DEFAULT : DexRadixSize.SMALL}
        >
          <DexIconHelp />
        </Button>
      </Dialog.Trigger>
      <Dialog.Content maxWidth="480px">
        <Dialog.Title>Contact support</Dialog.Title>
        <Dialog.Description size="2" color="gray" mb="3"></Dialog.Description>
        <Flex direction="column" gap="3" mb="4">
          {contacts.map(contact => (
            <Flex key={contact.email} direction="column">
              <Text size="2" weight="medium">
                {contact.name}
              </Text>
              <Link size="2" href={`mailto:${contact.email}`}>
                {contact.email}
              </Link>
            </Flex>
          ))}
        </Flex>
        <Flex justify="end">
          <Button variant="soft" onClick={() => setOpen(false)}>
            Close
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  )
}
